import { environment } from 'src/environment';
import { Component, HostListener, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as uikit from 'uikit'
import { PaymentService } from 'src/app/core/services/payment.service';
import { SessionService } from 'src/app/core/services/session.service';
import { R_ACCOUNT_SETTINGS } from '../../constants';
import { ApplicationService } from 'src/app/core/services/application.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { SelectPlanComponent } from '../select-plan/select-plan.component';
import { PaymentMethodTypeComponent } from '../payment-method-type/payment-method-type.component';
import { SignupStepComponent } from '../signup-step/signup-step.component';
import { PlanInfoComponent } from '../plan-info/plan-info.component';
import { CardPaymentComponent } from '../card-payment/card-payment.component';
import { IdealPaymentBankComponent } from '../ideal-payment-bank/ideal-payment-bank.component';
import { AccountCreatedComponent } from '../account-created/account-created.component';
@Component({
  selector: 'app-model-payment',
  templateUrl: `./model-payment.component.html`,
  styleUrls: [`./model-payment.component.scss`],
  standalone: true,
  imports: [NgIf, NgClass, NgStyle, SelectPlanComponent, PaymentMethodTypeComponent, SignupStepComponent, PlanInfoComponent, CardPaymentComponent, IdealPaymentBankComponent, AccountCreatedComponent]
})
export class ModelPaymentComponent implements OnInit {

  @Input() page;
  @Input() planData;
  step = 1;
  paymentDialog = true;
  nextDueMsg = '';
  paymentDetail;
  subTitleText = '';
  payment_type: any;
  paymentMethodLength: any;
  selectedPlanData: any;
  @Output() newItemEvent?= new EventEmitter<string>();

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private baseService: BaseService,
    private paymentService: PaymentService, private storageService: StorageService,
    private loggerService: LoggerService, private router: Router, private appService: ApplicationService,
    private subscriptionService: SubscriptionService, private uikitService: UikitService, private planService: PlanService) { }

  ngOnInit(): void {
    this.selectedPlanData = this.storageService.getSessionStore('selectedPlanData');
    const plansLength = this.planService.plansLength;
    this.paymentService.backNavigation.subscribe(data => {
      if (data === true) this.step = this.step - 1;
      if ((this.page === 'live' || this.page === 'account' || this.page === 'contentDetail') && this.paymentMethodLength == 1) this.step = 1;
    });
    if (this.storageService.getLocalStore('ideal_pay_success')) this.step = 4;
    else if (plansLength > 1) {
      this.step = 1;
    } else {
      const singlePlan = this.storageService.getSessionStore('selectedPlanData');
      if (!this.subscriptionService.userType) this.singlePlanPopUpPayment(singlePlan);
      // if (this.appService.userPaymentMethods.length > 1) this.step = 2;
      // else this.step = 3;
    }
  }

  @HostListener('window:beforeunload')
  closePopup() {
    if (this.storageService.getLocalStore('ideal_pay_redirect') && this.step == 4) {
      this.storageService.removeLocalStore('ideal_pay_success');
      this.storageService.removeLocalStore('ideal_pay_redirect');
    };
  }

  closePayment() {
    const paymentProcess = this.baseService.paymentProcessing.getValue();
    if (!paymentProcess) {
      // if(this.step === 3) location.reload();
      const modal = uikit.modal('#open-pay-dialog');
      modal.hide();
      this.step = 1;
    }
    this.storageService.removeLocalStore('ideal_pay_redirect');
    this.storageService.removeLocalStore('ideal_pay_success');
  }

  selectedPlan(e) {
    this.subscriptionService.paymentSessionId = e.session_id;
    if (e.freePlan) {
      this.step = 4;
    } else if (this.appService.userPaymentMethods?.length === 1) {
      this.step = 3;
      this.payment_type = this.appService.userPaymentMethods[0];
    } else {
      this.step = 2;
    }
  }

  cardMethod(e) {
    this.step = 3;
    this.paymentMethodLength = e.paymentMethodLength;
    this.paymentService.paymentMethodLength = e.paymentMethodLength;
    this.payment_type = e.payment_type;
  }

  cardPayment(e) {
    this.paymentDetail = e.url_data;
    if (this.paymentDetail) {
      this.subTitleText = this.paymentDetail.next_due_date ?
        ((this.configService.localeKeys?.["plans.next_payment_wii_be_charged.text"] || 'Your new plan will be valid starting from')
          + ' ' + this.paymentDetail.next_due_date +
          (this.configService.localeKeys?.["plans.next_payment_will_be_charged_part2.text"] || '.')) : '';
      this.step = 4;
      if (this.router.url == R_ACCOUNT_SETTINGS) this.newItemEvent.emit('');
    }
  }

  idealPayment(data) {
    this.baseService.loaderSource.next(false);
    this.step = 4;
    this.newItemEvent.emit('');
  }

  getSignStep($event) {
    this.step = $event;
  }

  async singlePlanPopUpPayment(selectedPlan) {
    this.storageService.setSessionStore('selectedPlanData', selectedPlan);

    if (selectedPlan.free_plan === 1) {
      // if plan is free plan
      const reqObj = {
        subscription_id: selectedPlan.subscription_id,
      };
      this.storageService.setLocalStore('subsId', selectedPlan.subscription_id);
      await this.subscriptionService.getFreePlanSubscription(reqObj).subscribe(res => {
        if (res) this.nextStepConditions(res, selectedPlan);
      });
    }  else if (selectedPlan?.type_of_plan === 'alliance_plan') {
      window.open(selectedPlan?.redirection_url, '_blank');
    } else {
      // if plan is not a free plan
      this.nonFreePlanPayment(selectedPlan);
    }
  }

  nonFreePlanPayment(selectedPlan) {
    this.baseService.disableFormBtnFn();
    // storing selected plan data as it is needed in other places like card details, signup page
    this.storageService.setSessionStore('selectedPlanData', selectedPlan);
    const postData = {
      u_id: this.storageService.getLocalStore('u_id'),
      subscription_id: selectedPlan.subscription_id,
      stripe_plan_id: selectedPlan.stripe_plan_id,
      pricing_plan_id: selectedPlan.pricing_plan_id,
    };
    this.storageService.setLocalStore('subsId', selectedPlan.subscription_id);
    this.loggerService.selectedPlanGTM(selectedPlan?.plan);
    this.subscriptionService.checkOut(postData).subscribe((data) => {
      if (data) {
        this.nextStepConditions(data, selectedPlan);
      }
    }, (error) => {
      if (error?.error?.error?.code !== 1002) {
        this.uikitService.notifyError(error);
      }
      if (error?.error?.error?.code === 2192) {
        this.router.navigateByUrl('/home')
      }
    });
  }

  nextStepConditions(data, selectedPlan) {
    this.subscriptionService.paymentSessionId = data.session_id;
    if (selectedPlan.free_plan) this.step = 4;
    else {
      if (this.appService.userPaymentMethods.length > 1) this.step = 2;
      else {
        this.step = 3;
        this.payment_type = this.appService.userPaymentMethods[0];
      }
    }
  }

}
